import { OrderType } from "../enums/order-type";

export const ORDER_TYPE_CONFIG: { [key in OrderType]: OrderTypeConfig } = {
  [OrderType.AWAITING_PROCUREMENT]: { label: 'Awaiting Procurement' },
  [OrderType.INTEGRATING_AND_TESTING]: { label: 'Integrating/Testing' },
  [OrderType.PACKING]: { label: 'Packing' },
  [OrderType.IN_TRANSIT]: { label: 'In Transit' },
  [OrderType.RECEIVED_BY_CUSTOMER]: { label: 'Received by Customer' },
  [OrderType.BRINGUP_DONE]: { label: 'Bringup Done' },
}

export type OrderTypeConfig = {
  label: string,
}
